import {Component, OnInit, ViewEncapsulation} from "@angular/core";
import {Quote} from "../../../_models/Quote";
import {CommonModule, DatePipe} from "@angular/common";
import {LabeledDisplayComponent} from "../../../shared/labeled-display/labeled-display.component";
import {QuoteService} from "../../../_services/quote.service";
import {ActivatedRoute, RouterModule} from "@angular/router";
import {catchError, finalize, map} from "rxjs/operators";
import {BaseComponent} from "../../../shared/base-component";
import {of} from "rxjs";
import {Plan} from "../../../_models/Plan";
import {ToastrService} from "ngx-toastr";
import {SweetAlert2Module} from "@sweetalert2/ngx-sweetalert2";
import {TemplateService} from "../../../_services/template.service";

@Component({
  templateUrl: './quote-details.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['quote-details.component.css'],
  imports: [
    DatePipe,
    LabeledDisplayComponent,
    CommonModule,
    RouterModule,
    CommonModule,
    SweetAlert2Module,
    CommonModule
  ]
})

export class QuoteDetailsComponent extends BaseComponent implements OnInit {

  constructor(private quoteService: QuoteService, private route: ActivatedRoute, toasterService: ToastrService, private templateService: TemplateService) {
    super(toasterService);
  }

  public quote: Quote;
  public quoteId: string;
  public templateUrl: string;
  public topdownTemplateUrl: string;
  public templateName: string;

  ngOnInit() {
    this.quoteId = this.route.snapshot.paramMap.get('id');
    this.getQuote();
  }

  getQuote() {
    this.quoteService.getQuote(this.quoteId).subscribe(quote => {
      this.quote = quote;
      if (this.quote?.fitrite365QuoteDetails.quoteType == 'BespokeQuote') {
        this.getBespoke365Template();
      }
      if (this.quote?.fitrite365QuoteDetails.quoteType == 'TemplateQuote') {
        this.getPlanTemplate();
      }
    })
  }

  markAsFinal(plan: Plan) {
    if (this.isLoading) {
      return;
    }

    this.loading['markAsFinal'] = true;
    this.quoteService.markAsFinal(plan.id)
      .pipe(
        map(r => {
          this.toasterService.success('Plan marked as final');
          this.getQuote();
        }),
        catchError(e => {
          this.showErrorToast(e);
          return of();
        }),
        finalize(() => this.loading['markAsFinal'] = false))
      .subscribe();
  }

  createContract() {
    if (this.loading.some(x => x)) {
      return;
    }

    if (this.quote.customer.onHold) {
      this.toasterService.error('Unable to send quote to order', 'Please contact Head Office');
      return;
    }

    this.loading['createContract'] = true;
    this.quoteService.createContract(this.quoteId).pipe(map(x => {
          this.toasterService.success('Contract created. This can take up to 5 minutes to sync');
          this.getQuote();
        }
      ),
      catchError(e => {
        this.showErrorToast(e);
        return of();
      }),
      finalize(() => this.loading['createContract'] = false))
      .subscribe();
  }

  getBespoke365Template() {
    this.templateService.getBespokeTemplateById(this.quote?.fitrite365QuoteDetails?.templateId)
      .subscribe(template => {
        this.templateUrl = template.templateWithKeyUrl;
        this.topdownTemplateUrl = template.overheadImageUrl;
        this.templateName = template.name;
      })
  }

  getPlanTemplate() {
    this.templateService.getPlanTemplateById(this.quote?.fitrite365QuoteDetails?.templateId)
      .subscribe(template => {
        this.templateName = template.description;
      })
  }

  isFullscreen = false;
  fullscreenUrl = '';

  openFullscreen(url: string) {
    this.fullscreenUrl = url;
    this.isFullscreen = true;
  }

  closeFullscreen() {
    this.isFullscreen = false;
    this.fullscreenUrl = '';
  }
}
